import React from 'react';
import Layout from '../components/Layout/Layout';
import libraryPdf from '../images/libraryinformation.pdf';
import libImage1 from '../images/library-info.jpg';
import libImage2 from '../images/library-info1.jpg';

const LibraryPage = () => {
  return (
    <Layout>
      <div id="library" className="page-container" style={{ maxWidth: '1100px', fontSize: '0.90rem', margin: '40px auto', padding: '0 20px', minHeight: '300px' }}>
        
        <h2 style={{ color: '#006622', borderBottom: '3px solid #006622', paddingBottom: '10px', marginBottom: '40px', textAlign: 'center', fontSize: '2.4rem', fontWeight: 'bold' }}>
          Library Information
        </h2>

        {/* Side-by-Side Images */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', marginBottom: '40px', justifyContent: 'center' }}>
          <div style={{ flex: '1 1 400px', backgroundColor: '#fff', border: '1px solid #eee', padding: '20px', borderRadius: '12px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <img src={libImage1} alt="Library Profile" style={{ maxWidth: '100%', maxHeight: '400px', objectFit: 'contain' }} />
          </div>
          <div style={{ flex: '1 1 400px', backgroundColor: '#fff', border: '1px solid #eee', padding: '20px', borderRadius: '12px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <img src={libImage2} alt="Library Area Info" style={{ maxWidth: '100%', maxHeight: '400px', objectFit: 'contain' }} />
          </div>
        </div>

        {/* PDF Embed Box */}
        <div style={{ backgroundColor: '#f0fff0', border: '2px solid #d9f2d9', padding: '30px', borderRadius: '12px', boxShadow: '0 4px 15px rgba(0,100,0,0.05)' }}>
          <h3 style={{ color: '#006622', textAlign: 'center', marginBottom: '25px', fontSize: '1.8rem', fontWeight: 'bold' }}>
            Library Information Document
          </h3>
          <iframe 
            src={libraryPdf} 
            width="100%" 
            height="800px" 
            title="Library PDF" 
            style={{ border: '1px solid #ccc', backgroundColor: '#333', borderRadius: '8px' }} 
          />
        </div>

      </div>
    </Layout>
  );
};

export default LibraryPage;
